// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zb8l","newExpiryDate":"styles_newExpiryDate__2J0cF","footer":"styles_footer__2SlMM"};